export default __webpack_public_path__ + "static/media/mic-on-green.156a5647.svg";